import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from 'projects/Administration/src/app/business-entities/brand.model';
import { RentalCarService } from 'projects/Administration/src/app/business-services/rental-car.service';
import { TechnicalManualBusinessService } from 'projects/Administration/src/app/business-services/technical-manual.service';
import * as Enums from '../../../../../../../../Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-add-technical-manual',
  templateUrl: './add-technical-manual.component.html'
})
export class AddTechnicalManualComponent implements OnInit {

  addTechnicalManual = false;
  addTechnicalManualForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private technicalmanualservice: TechnicalManualBusinessService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private activeModal: NgbActiveModal

  ) { }

  ngOnInit(): void {
    this.addTechnicalManualForm = this.formBuilder.group({
      brand: [null, [Validators.required]],
      manualUrl: ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      isActive: [true]
    });

    this.getBrandData();
  }

  async getBrandData() {
    await this.GetAllBrand();
  }
  get cpf() {
    return this.addTechnicalManualForm.controls;
  }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }
  OnClose() {
    this.activeModal.close({success:false})
  }
  addTechnicalManuals(): void {
    this.spinner.show();
    let currentUser = '';
    const viewModel: any = {
      ...this.addTechnicalManualForm.value,
      isActive: (this.addTechnicalManualForm.get('isActive').value === '' ? false : this.addTechnicalManualForm.get('isActive').value),
      createdBy: currentUser,
      brandCode: this.addTechnicalManualForm.get('brand').value
    }
    this.technicalmanualservice.addTechnicalManual(viewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        let addedTechnicalManual = this.translate.instant("lblTechnicalManualAdded");
        this.router.navigate(['technicalManual']);
        this.spinner.hide();
        this.activeModal.close({
          success: true
        });
        this.toastr.success(addedTechnicalManual);
      }
      else {
        let NotaddedTechnicalManual = this.translate.instant("lblTechnicalManualNotAdded");
        this.spinner.hide();
        this.toastr.error(NotaddedTechnicalManual);
      }
    })
    this.spinner.hide();
  }
}
